/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Swap_LaterInputs */

const en_us2_swap_later = /** @type {(inputs: Swap_LaterInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Do it later`)
};

const pt_br2_swap_later = /** @type {(inputs: Swap_LaterInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Fazer depois`)
};

const es_419_swap_later = /** @type {(inputs: Swap_LaterInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Hacerlo después`)
};

const pt_pt2_swap_later = /** @type {(inputs: Swap_LaterInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Fazer depois`)
};

const fr_fr2_swap_later = /** @type {(inputs: Swap_LaterInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Faire plus tard`)
};

const de_de2_swap_later = /** @type {(inputs: Swap_LaterInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Später machen`)
};

const it_it2_swap_later = /** @type {(inputs: Swap_LaterInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Fallo dopo`)
};

/**
* | output |
* | --- |
* | "Do it later" |
*
* @param {Swap_LaterInputs} inputs
* @param {{ locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }} options
* @returns {LocalizedString}
*/
const swap_later = /** @type {((inputs?: Swap_LaterInputs, options?: { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Swap_LaterInputs, { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pt-BR") return pt_br2_swap_later(inputs)
	if (locale === "es-419") return es_419_swap_later(inputs)
	if (locale === "pt-PT") return pt_pt2_swap_later(inputs)
	if (locale === "fr-FR") return fr_fr2_swap_later(inputs)
	if (locale === "de-DE") return de_de2_swap_later(inputs)
	if (locale === "it-IT") return it_it2_swap_later(inputs)
	return en_us2_swap_later(inputs)
});
export { swap_later as "swap.later" }